import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MainHubService } from '../../services/main-hub.service';

@Component({
  selector: 'app-view-ameritrade-login',
  templateUrl: './ameritradeLogin.component.html',
})
export class AmeritradeLoginComponent {



  constructor(private mainHubService: MainHubService, @Inject(DOCUMENT) private document: Document) {
   
  }

  async signIn() {
    let url = await this.mainHubService.getAmeritradeReturnUrl();
    document.location.href = url;
  }

}
